// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import InteractiveMapParameter from './InteractiveMapParameter';

const InteractiveMapTab = ({ parametersGroupData, context }) => {
  const { control } = useFormContext();
  return (
    <Grid container>
      {parametersGroupData.parameters.map((parameter) => (
        <Controller
          key={parameter.id}
          name={parameter.id}
          control={control}
          render={({ field }) => (
            <InteractiveMapParameter
              parameterData={parameter}
              context={context}
              parameterValue={field.value}
              setParameterValue={field.onChange}
            />
          )}
        />
      ))}
    </Grid>
  );
};

InteractiveMapTab.propTypes = {
  parametersGroupData: PropTypes.object.isRequired,
  context: PropTypes.object.isRequired,
};

export default InteractiveMapTab;
